import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { MaskedReveal, FadeUp } from "./MaskedReveal";

const TESTIMONIALS = [
  {
    quote:
      "Leonard Technology took over our infrastructure and the noise just stopped. No more midnight outages, no more finger-pointing. They run IT so we can run the business.",
    name: "Marcus Reyes",
    role: "COO, Vantage Logistics",
    image:
      "https://images.pexels.com/photos/18321496/pexels-photo-18321496.jpeg",
  },
  {
    quote:
      "Our last security audit was the smoothest we've ever had. Everything was already in place. That peace of mind is worth every penny.",
    name: "Priya Nadella",
    role: "CFO, Meridian Health Group",
  },
  {
    quote:
      "The helpdesk actually answers. Real engineers who know our setup. Our team stopped dreading IT tickets entirely.",
    name: "Daniel Okafor",
    role: "Operations Lead, Northwind Retail",
  },
];

export const Testimonials = () => {
  const [feature, ...rest] = TESTIMONIALS;
  return (
    <section
      id="voices"
      data-testid="testimonials-section"
      className="relative bg-[#050505] py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-20 max-w-2xl">
          <p className="text-xs uppercase tracking-[0.28em] text-[#00E5FF] font-bold mb-6">
            Client voices
          </p>
          <MaskedReveal
            as="h2"
            testId="testimonials-heading"
            lines={["Trusted where", "downtime isn't an option."]}
            className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter text-white leading-[0.95]"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {/* Featured with portrait */}
          <FadeUp
            testId="testimonial-featured"
            className="lg:col-span-7 relative overflow-hidden rounded-2xl border border-white/10 bg-[#0A0A0C] min-h-[420px] flex"
          >
            <div className="absolute inset-0 z-0">
              <img
                src={feature.image}
                alt={feature.name}
                loading="lazy"
                className="h-full w-full object-cover opacity-40 mix-blend-luminosity grayscale"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0C] via-[#0A0A0C]/80 to-transparent" />
            </div>
            <div className="relative z-10 p-8 md:p-12 flex flex-col justify-between">
              <Quote size={40} className="text-[#00E5FF]" />
              <div>
                <p className="text-xl md:text-2xl font-medium text-white leading-snug max-w-lg">
                  “{feature.quote}”
                </p>
                <div className="mt-8">
                  <p className="font-semibold text-white">{feature.name}</p>
                  <p className="text-sm text-[#A0AEC0]">{feature.role}</p>
                </div>
              </div>
            </div>
          </FadeUp>

          {/* Two stacked quotes */}
          <div className="lg:col-span-5 flex flex-col gap-5">
            {rest.map((t, i) => (
              <FadeUp
                key={i}
                delay={0.1 + i * 0.08}
                testId={`testimonial-${i}`}
                className="flex-1 rounded-2xl border border-white/10 bg-[#0A0A0C] p-8 flex flex-col justify-between hover:border-[#00E5FF]/30 transition-colors duration-500"
              >
                <p className="text-base md:text-lg text-white/90 leading-relaxed">
                  “{t.quote}”
                </p>
                <div className="mt-6">
                  <p className="font-semibold text-white">{t.name}</p>
                  <p className="text-sm text-[#A0AEC0]">{t.role}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
